import { getBuilding, searchBuildings } from 'shared/api/buildings';
import { getComplex, searchComplexes } from 'shared/api/complexes';
import { getDirectvPackage, searchDirectvPackages } from 'shared/api/directv';
import { getManager, searchManagers } from 'shared/api/managers';
import {
  getNas, getNasProfile, searchNases, searchNasProfiles,
} from 'shared/api/nases';
import { getQos, getQoses } from 'shared/api/qos';
import {
  getAccessControl,
  getFire,
  getIntrusion,
  getSurveillance,
  searchAccessControl,
  searchFire,
  searchIntrusion,
  searchSurveillance,
} from 'shared/api/security';
import { getTenant, searchTenants } from 'shared/api/tenants';
import { getSatellitePkg, searchSatellitePkgs } from 'shared/api/satellite-pkgs';
import { getVsz, searchVszs } from 'shared/api/vsz';
import {
  getUser, getUserGroup, searchUserGroups, searchUsers,
} from 'shared/api/admin';
import {
  getResolutions, getTag, searchResolutions, searchTags,
} from 'shared/api/support';
import {
  createAdminNas,
  deleteAdminNas,
  getAdminNas,
  searchAdminNas,
  updateAdminNas,
} from 'shared/api/admin-radius';
import { formatEmployeeName } from 'shared/utils';
import { formatTenantName } from 'shared/utils/formatters';
import { getUnit, searchBuildingUnits } from './api/units';

export const accessControlEntity = {
  name: 'Access Control',
  getRequest: getAccessControl,
  searchRequest: searchAccessControl,
};

export const buildingEntity = {
  name: 'Building',
  preloadOptions: false,
  getRequest: getBuilding,
  label: 'Buildings',
  searchRequest: searchBuildings,
};
export const unitEntity = {
  name: 'Unit',
  preloadOptions: true,
  getRequest: getUnit,
  label: 'Units',
  getOptionLabel: (e) => e?.name,
  getOptionValue: (e) => e?.id,
  searchRequest: (
    buildingId,
    search,
  ) => searchBuildingUnits(search, undefined, buildingId),
};
export const complexEntity = {
  name: 'Complex',
  getRequest: getComplex,
  searchRequest: searchComplexes,
  label: 'Complexes',
};
export const dtvEntity = {
  name: 'DTV Package',
  getRequest: getDirectvPackage,
  searchRequest: searchDirectvPackages,
};
export const employeeEntity = {
  name: 'Employee',
  getOptionLabel: (e) => `${(formatEmployeeName(e))}${e.email ? ` (${e.email})` : ''}`,
  getOptionValue: (e) => e.employeeId,
  getRequest: getUser,
  searchRequest: searchUsers,
  label: 'Employees',
};

export const userGroupEntity = {
  name: 'User Group',
  getOptionLabel: (e) => e.group_name,
  getOptionValue: (e) => e.id,
  getRequest: getUserGroup,
  searchRequest: searchUserGroups,
  label: 'User Group',
};

export const fireEntity = {
  name: 'Fire',
  getRequest: getFire,
  searchRequest: searchFire,
};
export const intrusionEntity = {
  name: 'Intrusion',
  getRequest: getIntrusion,
  searchRequest: searchIntrusion,
};
export const managerEntity = {
  name: 'Manager',
  getRequest: getManager,
  searchRequest: searchManagers,
};

export const nasEntity = {
  name: 'Nas',
  getOptionLabel: (n) => `${n.nas_name}${n.description ? ` (${n.description})` : ''}`,
  getRequest: getNas,
  label: 'Nases',
  searchRequest: searchNases,
};

export const qosEntity = {
  name: 'QOS',
  label: 'QOS',
  getOptionLabel: (qos) => qos.description,
  getRequest: getQos,
  searchRequest: getQoses,
};

export const resolutionEntity = {
  name: 'Resolutions',
  getRequest: getResolutions,
  label: 'Resolution',
  searchRequest: searchResolutions,
};

export const satellitePkgEntity = {
  name: 'Satellite Packages',
  getRequest: getSatellitePkg,
  searchRequest: searchSatellitePkgs,
};
export const surveillanceEntity = {
  name: 'Surveillance',
  getRequest: getSurveillance,
  searchRequest: searchSurveillance,
};
export const tenantEntity = {
  name: 'Tenant',
  getOptionLabel: (t) => `${formatTenantName(t)}${t.email ? ` (${t.email})` : ''}`,
  getRequest: getTenant,
  searchRequest: searchTenants,
  label: 'Tenants',
};

export const ticketTagEntity = {
  getOptionLabel: (tt) => tt.name,
  getRequest: getTag,
  label: 'Ticket Tag',
  searchRequest: searchTags,
};

export const vszEntity = {
  name: 'VSZ',
  getOptionLabel: (vsz) => `${vsz.ip} (ver.${vsz.version})`,
  label: 'VSZ',
  getRequest: getVsz,
  searchRequest: searchVszs,
};
// TODO: evaluate entity name
export const adminNasEntity = {
  name: 'Nas',
  getOptionLabel: (n) => {
    if (n?.short_name) {
      return `${n?.nas_name} (${n?.short_name})`;
    }
    return n?.nas_name || n.name;
  },
  getOptionValue: (n) => n.nas_name || n.name,
  getRequest: getAdminNas,
  label: 'Nases',
  queryKey: 'nas_id',
  searchRequest: searchAdminNas,
  updateRequest: updateAdminNas,
  // this will delete the all ics_auth_radius and radius entries for equipment
  // (e.g. radcheck, tenant nas, VTR, etc.)
  deleteRequest: deleteAdminNas,
  createRequest: createAdminNas,
};

export const vtrEntity = {
  name: 'VTRs',
  getOptionLabel: (np) => np.ip,
  getRequest: getNasProfile,
  label: 'VTRs',
  searchRequest: searchNasProfiles,
};
